import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toLbs'
})
export class ToLbsPipe implements PipeTransform {

  transform(value: string, args?: any): number {
    if (value && (typeof value === 'string')) {
      value = value.replace(' St', '').replace(' lbs', '').replace(' ', '.');
      const values = value.split('.');
      // If the second parameter, is not present, it means the weight is under 1 stone
      if (values.length > 1) {
        const stones = Number(values[0]);
        const lbs = Number(values[1]);
        return Number(((stones * 14) + lbs).toFixed(1));
      } else {
        const lbs = Number(values[0]);
        return Number(lbs.toFixed(1));
      }
    } else {
      return Number(value);
    }

  }

}
